import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ios-download',
  templateUrl: './ios-download.component.html',
  styleUrls: ['./ios-download.component.scss'],
})
export class IosDownloadComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
